import React from 'react';
import { Link } from 'react-router-dom';
import './Programs.css';
import { FaGraduationCap, FaRunning, FaLeaf, FaHandsHelping, FaUserCheck } from 'react-icons/fa';

function Programs() {
  const programs = [
    {
      id: 'education',
      icon: FaGraduationCap,
      title: 'Education',
      description: 'Supporting youth through education, career guidance, and scholarship programs. Empowering marginalized communities with knowledge and skills.',
      link: '/education',
      color: '#ff9933'
    },
    {
      id: 'sports',
      icon: FaRunning,
      title: 'Sports',
      description: 'Promoting physical wellness, yoga, and sports excellence. Developing future athletes through training and competitions at all levels.',
      link: '/sports',
      color: '#138808'
    },
    {
      id: 'environment',
      icon: FaLeaf,
      title: 'Environment',
      description: 'Tree plantation drives and environmental conservation. Building green communities through sustainable practices and awareness.',
      link: '/environment',
      color: '#3498db'
    },
    {
      id: 'social',
      icon: FaHandsHelping,
      title: 'Social Welfare',
      description: 'Empowering women and children through health, hygiene, and resource support. Creating inclusive communities with essential assistance.',
      link: '/welfare',
      color: '#9b59b6'
    },
    {
      id: 'information',
      icon: FaUserCheck,
      title: 'Information Center',
      description: 'Competitive exam preparation for SSC, RRB, Banking, TSPSC, TET, and Police exams. Guiding aspirants to success through quality training.',
      link: '/education',
      color: '#e74c3c'
    }
  ];

  return (
    <section id="programs" className="programs">
      <div className="container">
        <div className="section-header">
          <h2>Our Programs</h2>
          <div className="underline"></div>
          <p className="section-description">
            Pramila Foundation works across multiple domains to create lasting positive impact
          </p>
        </div>
        
        <div className="program-cards">
          {programs.map((program) => {
            const IconComponent = program.icon;
            return (
              <Link to={program.link} key={program.id} className="program-link-wrapper">
                <div id={program.id} className="program-card">
                  <div className="program-top-bar" style={{ backgroundColor: program.color }}></div>
                  <div className="program-icon">
                    <IconComponent />
                  </div>
                  <h3>{program.title}</h3>
                  <p className="program-description">{program.description}</p>
                  <div className="program-cta">Learn More →</div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Programs;
